import styled from 'styled-components';
import { Typ31 } from 'dc/Typ';
import Lab010 from 'dc/Lab010';
import PodiumImage from '../PodiumImage';

export const Image = styled(PodiumImage)`
  margin-bottom: 8px;
`;

export const Name = styled(Typ31)`
  width: 95%;
  max-width: 120px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 4px;
  text-align: center;
`;

export const Label = styled(Lab010)`
  margin-bottom: 16px;
  span {
    color: #263238;
    font-weight: bold;
  }
`;
